import React from "react";

import Button from "../../button/Button";
import useThemeService from "../../../services/theme-service/ThemeService";
import { Download } from "../../svg/svgImageList";

export interface DownloadButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  labelKey?: string;
}

export default function DownloadButton({ onClick, disabled, labelKey }: DownloadButtonProps) {
  const { themeClass } = useThemeService();

  return (
    <Button
      id="download"
      onClick={onClick}
      disabled={disabled}
      icon={{
        svg: Download,
        textKey: labelKey ? labelKey : "general.download",
        textClass: "actions-header-button-label",
        className: themeClass(["icon-download"]),
      }}
    />
  );
}
